(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-with-filters"]) return;
  try {
    
function applyFilters() {
  const products = document.querySelectorAll('.product-card');
  const selectedCollections = Array.from(document.querySelectorAll('input[name="collection"]:checked')).map(cb => cb.value);
  const selectedVendors = Array.from(document.querySelectorAll('input[name="vendor"]:checked')).map(cb => cb.value);
  const selectedTypes = Array.from(document.querySelectorAll('input[name="product_type"]:checked')).map(cb => cb.value);
  const minPrice = parseFloat(document.getElementById('min-price').value) || 0;
  const maxPrice = parseFloat(document.getElementById('max-price').value) || Infinity;
  
  let visibleCount = 0;
  
  products.forEach(product => {
    let show = true;
    
    // Collection filter
    if (selectedCollections.length > 0) {
      // This would need URL parameters or collection context
    }
    
    // Vendor filter
    if (selectedVendors.length > 0 && !selectedVendors.includes(product.dataset.vendor)) {
      show = false;
    }
    
    // Type filter
    if (selectedTypes.length > 0 && !selectedTypes.includes(product.dataset.type)) {
      show = false;
    }
    
    // Price filter
    const price = parseFloat(product.dataset.price);
    if (price < minPrice || price > maxPrice) {
      show = false;
    }
    
    product.style.display = show ? 'block' : 'none';
    if (show) visibleCount++;
  });
  
  // Update product count
  const countElement = document.querySelector('.product-count');
  if (countElement) {
    countElement.textContent = `${visibleCount} Produkte`;
  }
  
  // Show/hide no products message
  const noProducts = document.querySelector('.no-products');
  if (noProducts) {
    noProducts.style.display = visibleCount === 0 ? 'block' : 'none';
  }
}

function clearAllFilters() {
  document.querySelectorAll('.filter-sidebar input[type="checkbox"]').forEach(cb => cb.checked = false);
  document.getElementById('min-price').value = '';
  document.getElementById('max-price').value = '';
  applyFilters();
}

function sortProducts() {
  const sortValue = document.getElementById('sort-by').value;
  const grid = document.getElementById('products-grid');
  const products = Array.from(grid.querySelectorAll('.product-card'));
  
  products.sort((a, b) => {
    switch (sortValue) {
      case 'price-ascending':
        return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
      case 'price-descending':
        return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
      case 'title-ascending':
        return a.dataset.title.localeCompare(b.dataset.title);
      case 'title-descending':
        return b.dataset.title.localeCompare(a.dataset.title);
      default:
        return 0;
    }
  });
  
  // Re-append sorted products
  products.forEach(product => grid.appendChild(product));
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
let currentSlide = 0;

function changeSlide(direction) {
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  
  slides[currentSlide].classList.remove('active');
  dots[currentSlide].classList.remove('active');
  
  currentSlide = (currentSlide + direction + slides.length) % slides.length;
  
  slides[currentSlide].classList.add('active');
  dots[currentSlide].classList.add('active');
}

function goToSlide(index) {
  const slides = document.querySelectorAll('.hero-slide');
  const dots = document.querySelectorAll('.hero-dot');
  
  slides[currentSlide].classList.remove('active');
  dots[currentSlide].classList.remove('active');
  
  currentSlide = index;
  
  slides[currentSlide].classList.add('active');
  dots[currentSlide].classList.add('active');
}

// Auto-advance slides every 5 seconds
setInterval(() => {
  if (document.querySelectorAll('.hero-slide').length > 1) {
    changeSlide(1);
  }
}, 5000);

  } catch(e) { console.error(e); }
})();
})();
